<template>
  <div id='bd-main'>
    <el-table :data="userSummaries.content" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="thread.visitor.nickname" label="姓名" width="185"></el-table-column>
      <el-table-column prop="content" label="内容"></el-table-column>
      <el-table-column prop="tags" label="标签">
        <template slot-scope="scope">
          <el-tag v-for="tag in scope.row.tags" :key="tag.id" size="mini">{{ tag.name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="时间"></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120">
        <!-- <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index, tableData)"
            type="text"
            size="small">
            查看
          </el-button>
        </template> -->
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="userSummaries.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      resize: true
    }
  },
  computed: {
    ...mapGetters([ 'userSummaries' ])
  },
  methods: {
    ...mapActions([ 'querySummaries' ]),
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let payload = { page: val - 1, size: 10 }
    this.querySummaries(payload)
    }
  },
  created() {
    let payload = { page: 0, size: 10 }
    this.querySummaries(payload)
  },

}
</script>

<style scoped>

</style>
